import { render } from "./BasketItem_confirmation.vue?vue&type=template&id=310463ac"
import script from "./BasketItem_confirmation.vue?vue&type=script&lang=js"
export * from "./BasketItem_confirmation.vue?vue&type=script&lang=js"

import "./BasketItem_confirmation.vue?vue&type=style&index=0&id=310463ac&lang=scss"

import exportComponent from "/codebuild/output/src4153154969/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__